<template>
    <NotificationGroup group="success">
        <div class="fixed inset-0 flex items-start justify-end p-6 px-4 py-6 pointer-events-none z-[1000]">
            <div class="w-full max-w-sm">
                <Notification
                    ref="successNotif"
                    v-slot="{ notifications, close }"
                    enter="transform ease-out duration-300 transition"
                    enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                    enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                    leave="transition ease-in duration-500"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                    move="transition duration-500"
                    move-delay="delay-300"
                >
                    <div
                        class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow-md pointer-events-auto"
                        v-for="notification in notifications"
                        :key="notification.id"
                        :class="notification.url ? 'cursor-pointer hover:shadow-lg transition-shadow' : ''"
                        @click="handleNotificationClick(notification, close)"
                        @mouseenter="pauseTimer(notification.id)"
                        @mouseleave="resumeTimer(notification.id, close)"
                    >
                        <div class="flex items-center justify-center w-12 bg-green-500">
                            <check-circle-icon class="w-6 h-6 text-white"></check-circle-icon>
                        </div>

                        <div class="px-4 py-2 -mx-3 flex-1">
                            <div class="mx-3">
                                <span class="font-semibold text-green-500">{{ $t(notification.title) }}</span>
                                <div class="max-h-48 overflow-y-auto pr-1 custom-scrollbar">
                                    <p class="text-sm text-gray-600 whitespace-pre-wrap">
                                        <template v-if="!expandedNotifications[notification.id] && $t(notification.text).length > ($page.props.CHAT_NOTIFICATION_MSG_LONG_TEXT_CHAR || 100)">
                                            {{ $t(notification.text).substring(0, ($page.props.CHAT_NOTIFICATION_MSG_LONG_TEXT_CHAR || 100)) }}...
                                            <button @click.stop="expandedNotifications[notification.id] = true" class="text-blue-500 font-bold ml-1 hover:underline">{{ $t('chat.seeMore') }}</button>
                                        </template>
                                        <template v-else>
                                            {{ $t(notification.text) }}
                                            <button v-if="expandedNotifications[notification.id]" @click.stop="expandedNotifications[notification.id] = false" class="text-blue-500 font-bold ml-1 hover:underline">{{ $t('chat.seeLess') }}</button>
                                        </template>
                                    </p>
                                </div>
                                <p v-if="notification.url" class="text-xs text-minplan-blue mt-1">{{ $t('chat.openChat') }}</p>
                            </div>
                        </div>
                    </div>
                </Notification>
            </div>
        </div>
    </NotificationGroup>
    <NotificationGroup group="error">
        <div
            class="fixed inset-0 flex items-start justify-end p-6 px-4 py-6 pointer-events-none z-[1000]"
        >
            <div class="w-full max-w-sm">
                <Notification
                    ref="errorNotif"
                    v-slot="{ notifications, close }"
                    enter="transform ease-out duration-300 transition"
                    enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                    enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                    leave="transition ease-in duration-500"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                    move="transition duration-500"
                    move-delay="delay-300"
                >
                    <div
                        class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow-md pointer-events-auto"
                        v-for="notification in notifications"
                        :key="notification.id"
                        :class="notification.url ? 'cursor-pointer hover:shadow-lg transition-shadow' : ''"
                        @click="handleNotificationClick(notification, close)"
                        @mouseenter="pauseTimer(notification.id)"
                        @mouseleave="resumeTimer(notification.id, close)"
                    >
                        <div class="flex items-center justify-center w-12 bg-red-500">
                            <exclamation-circle-icon class="w-6 h-6 text-white"></exclamation-circle-icon>
                        </div>

                        <div class="px-4 py-2 -mx-3 flex-1">
                            <div class="mx-3">
                                <span class="font-semibold text-red-500">{{ $t(notification.title) }}</span>
                                <div class="max-h-48 overflow-y-auto pr-1 custom-scrollbar">
                                    <p class="text-sm text-gray-600 whitespace-pre-wrap">
                                        <template v-if="!expandedNotifications[notification.id] && $t(notification.text).length > ($page.props.CHAT_NOTIFICATION_MSG_LONG_TEXT_CHAR || 100)">
                                            {{ $t(notification.text).substring(0, ($page.props.CHAT_NOTIFICATION_MSG_LONG_TEXT_CHAR || 100)) }}...
                                            <button @click.stop="expandedNotifications[notification.id] = true" class="text-blue-500 font-bold ml-1 hover:underline">{{ $t('chat.seeMore') }}</button>
                                        </template>
                                        <template v-else>
                                            {{ $t(notification.text) }}
                                            <button v-if="expandedNotifications[notification.id]" @click.stop="expandedNotifications[notification.id] = false" class="text-blue-500 font-bold ml-1 hover:underline">{{ $t('chat.seeLess') }}</button>
                                        </template>
                                    </p>
                                </div>
                                <p v-if="notification.url" class="text-xs text-minplan-blue mt-1">{{ $t('actions.open') }}</p>
                            </div>
                        </div>
                    </div>
                </Notification>
            </div>
        </div>
    </NotificationGroup>

</template>

<script>
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/vue/outline/index";
import { Inertia } from "@inertiajs/inertia";

export default {
    name: "Toast",
    props: ["group"],
    components: {
        CheckCircleIcon,
        ExclamationCircleIcon
    },
    data() {
        return {
            expandedNotifications: {},
            customTimeouts: {},
        };
    },
    computed: {
        pageFlashes() {
            return this.$page.props.flash;
        },
    },
    watch: {
        pageFlashes: {
            handler(flash){
                // if(!flash){
                //     return;
                // }
                // this.$notify({
                //     group: "success",
                //     title:flash.title,
                //     text: flash.message
                // }, 2000);

            }
        }
    },
    methods: {
        handleNotificationClick(notification, close) {
            if (!notification?.url) return;

            close(notification.id);
            Inertia.visit(notification.url);
        },
        pauseTimer(id) {
            const groups = [this.$refs.successNotif, this.$refs.errorNotif];
            for (const group of groups) {
                if (group && group.timeouts && group.timeouts[id]) {
                    clearTimeout(group.timeouts[id]);
                }
            }
            if (this.customTimeouts[id]) {
                clearTimeout(this.customTimeouts[id]);
            }
        },
        resumeTimer(id, close) {
            if (this.customTimeouts[id]) {
                clearTimeout(this.customTimeouts[id]);
            }
            this.customTimeouts[id] = setTimeout(() => {
                close(id);
                delete this.customTimeouts[id];
            }, 3000);
        },
    }

};
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar {
    width: 4px;
}
.custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}
</style>
